export default "__VITE_ASSET__DRtOMbUV__"